"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/layout/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var inventoryRouter = {
  path: '/inventory',
  component: _index.default,
  redirect: '/inventory/goods',
  name: 'Inventory',
  meta: {
    title: '仓库',
    icon: 'receiving'
  },
  children: [{
    path: 'goods',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/inventory/goods/Index.vue'));
      });
    },
    name: 'goods',
    meta: {
      title: '仓库商品'
    }
  }, {
    path: 'inquiry',
    name: 'inquiry',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/inventory/inquiry/Index.vue'));
      });
    },
    meta: {
      title: '仓库日志'
    },
    children: [{
      path: 'transaction',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/inventory/inquiry/transaction/Index.vue'));
        });
      },
      name: 'transaction',
      meta: {
        title: '库存流水'
      }
    }, {
      path: 'counting',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/inventory/inquiry/counting/Index.vue'));
        });
      },
      name: 'inquiry-counting',
      meta: {
        title: '盘库明细'
      }
    }]
  }, {
    path: 'operations',
    name: 'operations',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/inventory/operations/Index.vue'));
      });
    },
    meta: {
      title: '仓库操作'
    },
    children: [{
      path: 'in-bound',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/inventory/operations/BasicInOut.vue'));
        });
      },
      name: 'in-bound',
      meta: {
        title: '入库',
        keepAlive: true,
        bizType: 'IN'
      }
    }, {
      path: 'out-bound',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/inventory/operations/BasicInOut.vue'));
        });
      },
      name: 'out-bound',
      meta: {
        title: '出库',
        keepAlive: true,
        bizType: 'OUT'
      }
    }, {
      path: 'counting',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/inventory/operations/counting/Index.vue'));
        });
      },
      name: 'counting',
      meta: {
        title: '盘库'
      }
    }, {
      path: 'in-stock',
      component: function component() {
        return Promise.resolve().then(function () {
          return _interopRequireWildcard(require('@/views/inventory/operations/inStock/Index.vue'));
        });
      },
      name: 'in-stock',
      meta: {
        title: '库存查询'
      }
    }]
  }]
};
var _default = exports.default = inventoryRouter;